@if (isStep2) {
  <app-form-activity-pickup-step2> </app-form-activity-pickup-step2>
} @else {
  <app-form-activity-pickup-step1></app-form-activity-pickup-step1>
}
